import gql from "graphql-tag";

// Get list of designation
const GET_DEPARTMENT = gql`
	query Get_Departments($site: ID!) {
		GetDepartments(site: $site) {
			docs {
				created_at
				id
				name
			}
		}
	}
`;

// New Department
const NEW_DEPARTMENT = gql`
	mutation NewDepartment($name: String!, $site: ID!) {
		CreateDepartment(name: $name, site: $site) {
			message
			doc {
				name
				id
				created_at
			}
		}
	}
`;
// Update Department
const UPDATE_DEPARTMENT = gql`
	mutation UpdateDepartment($name: String!, $id: ID!) {
		UpdateDepartment(name: $name, id: $id) {
			message
			doc {
				name
				id
				created_at
			}
		}
	}
`;

export { GET_DEPARTMENT, NEW_DEPARTMENT, UPDATE_DEPARTMENT };
